import { useCallback, useEffect, useState } from 'react';

import { useYearQuarterNavigation } from 'hooks';
import { useRecoilValue } from 'recoil';

import { CalculatedWorkDemand } from 'components/types';

import { getCalculatedWorkDemand } from 'RestAPIs/care-demand';

import { scenarioAtom } from '../atoms';

import { Box } from '@mui/material';

import { LoadingOverlay } from 'components/shared';

import NoScenario from '../components/NoScenario';
import WorkDemandGrid from './components/WorkDemandGrid';
import WorkDemandTotals from './components/WorkDemandTotals/WorkDemandTotals';
import { AggregateOn } from 'components/enums';

const WorkDemandTab = () => {
  const [totalWorkDemand, setTotalWorkDemand] =
    useState<CalculatedWorkDemand | null>(null);
  const [isLoadingTotals, setIsLoadingTotals] = useState<boolean>(false);
  const scenario = useRecoilValue(scenarioAtom);
  const { aggregate, year } = useYearQuarterNavigation();

  const loadTotalWorkDemand = useCallback(() => {
    if (scenario && scenario.scenarioId) {
      setIsLoadingTotals(true);
      getCalculatedWorkDemand({
        scenarioId: scenario.scenarioId,
        year,
        aggregateOn: aggregate || AggregateOn.MONTH
      })
        .then(({ data }) => {
          setTotalWorkDemand(data);
        })
        .finally(() => {
          setIsLoadingTotals(false);
        });
    }
  }, [scenario, year, aggregate]);

  useEffect(() => {
    loadTotalWorkDemand();
  }, [scenario, year, aggregate]);

  const onMutateWorkDemand = useCallback(
    () => loadTotalWorkDemand(),
    [scenario, loadTotalWorkDemand]
  );

  if (!scenario) {
    return <NoScenario />;
  }

  return (
    <Box>
      <LoadingOverlay loading={isLoadingTotals} />
      <Box mb={4}>
        <WorkDemandTotals
          isLoading={isLoadingTotals}
          totalWorkDemand={totalWorkDemand}
        />
      </Box>
      <WorkDemandGrid
        scenario={scenario}
        updateTotals={() => onMutateWorkDemand()}
      />
    </Box>
  );
};

export default WorkDemandTab;
